import OverView from "../components/dashboard/overView";
import Items from "../components/dashboard/items";
import Settings from "../components/dashboard/settings";
import CustomerManagement from "../components/dashboard/customerManagement";
import Billing from "../components/billing/billing";
import Billing2 from "../components/billing/index";
import Reports from "../components/dashboard/reports";
import loyaltyPoints from "../components/dashboard/LoyaltyPoints";
import CustomerLoyaltyDetails from "../components/dashboard/customerLoyaltyDetails";
import stockValueReport from "../components/dashboard/stockValueReport";
import ProductExcelUpload from "../components/dashboard/productExcelUpload";
import LoyaltyDashboard from "../components/dashboard/loyaltyDashboard";
import EmployeeAccess from "../components/dashboard/employeeAccess";
import PurchaseOrder from "../components/dashboard/purchaseOrder";
import ProductPriceBuldUpdate from "../components/dashboard/productPriceBuldUpdate";
import CustomerBillHistory from "../components/dashboard/customerBillHistory";
import CustomerOutstandings from "../components/dashboard/customerOutstandings";
import VendorMangagement from "../components/dashboard/Vendor management/vendor";
import VendorBillDetails from "../components/dashboard/Vendor management/vendorDetails";
import VendorAddBill from "../components/dashboard/Vendor management/vendorAddBill";
import VendorBillHistory from "../components/dashboard/Vendor management/billHistory";
import TaxMasterpage from "../components/dashboard/Tax Master/index";
import AddCategories from "../components/dashboard/addCategories";
import AddCategoriesNew from "../components/dashboard/addCategoriesNew";
import KitchenOrderView from "../components/Kitchen/Kitchen order view";
import KOT from "../components/Kitchen/KOT";
import Subscription from "../components/subscription/subscription";
import CreateSubcription from "../components/subscription/createSubcription";
import CashManagement from "../components/cash-counter/cash-counter";
import OutletTabs from "../components/outlet/outletTabs";
import Expenses from "../components/expenses-management/expenses";
import Loyalty from "../components/dashboard/loyalty";
import PlanAndPricing from "../components/planAndPricing";

// import SupportForm from "../components/support";

export default [
  {
    component: OverView,
    path: "/",
    title: "Dashboard",
  },
  {
    component: OverView,
    path: "/dashboard",
    title: "Dashboard",
  },
  {
    component: OverView,
    path: "/dashboard/overview",
    title: "Dashboard",
  },
  {
    component: Items,
    path: "/dashboard/shop-items",
    title: "Shop Items",
  },
  {
    component: ProductExcelUpload,
    path: "/dashboard/excel-upload",
  },
  {
    component: CustomerManagement,
    path: "/dashboard/customer-management",
    title: "Customer",
  },
  {
    component: Settings,
    path: "/dashboard/settings",
    title: "Settings",
  },

  {
    component: Reports,
    path: "/dashboard/reports",
    title: "Reports",
  },
  {
    component: Loyalty,
    path: "/dashboard/loyalty-dashboard",
    title: "Loyalty",
  },
  {
    component: stockValueReport,
    path: "/dashboard/stock-value-report",
    title: "Reports",
  },
  // {
  //   component: Billing,
  //   path: "/billing2",
  //   title: "Billing",
  // },
  // {
  //   component: Billing2,
  //   path: "/billing",
  //   title: "Billing",
  // },
  {
    component: Loyalty,
    path: "/dashboard/loyalty",
    title: "Loyalty",
  },
  {
    component: CustomerLoyaltyDetails,
    path: "/dashboard/loyalty-details",
    title: "Loyalty",
  },
  {
    component: EmployeeAccess,
    path: "/dashboard/employeeAccess",
    title: "Employee",
  },
  {
    component: PurchaseOrder,
    path: "/dashboard/purchaseOrder",
  },
  {
    component: ProductPriceBuldUpdate,
    path: "/dashboard/bulk-price-update",
    title: "Shop Items",
  },
  {
    component: CustomerOutstandings,
    path: "/dashboard/customer-management/outstandings",
    title: "Customer",
  },
  {
    component: CustomerBillHistory,
    path: "/dashboard/customer-management/bill-history",
    title: "Customer",
  },
  {
    component: VendorMangagement,
    path: "/dashboard/vendor-management",
    title: "Vendor",
  },
  {
    component: VendorBillDetails,
    path: "/dashboard/vendor-management/vendor-details",
    title: "Vendor",
  },
  {
    component: VendorAddBill,
    path: "/dashboard/vendor-management/add-bill",
    title: "Vendor",
  },
  {
    component: VendorBillHistory,
    path: "/dashboard/vendor-management/bill-history",
    title: "Vendor",
  },
  {
    component: TaxMasterpage,
    path: "/dashboard/shop-items/tax-master",
    title: "Tax Master",
  },
  {
    component: AddCategories,
    path: "/dashboard/addCategories",
  },
  {
    component: AddCategoriesNew,
    path: "/dashboard/addCategoriesNew",
  },
  {
    component: KitchenOrderView,
    path: "/dashboard/order-display",
    title: "Orders",
  },
  // {
  //   component: KOT,
  //   path: "/kitchen-billing",
  // },
  {
    component: Subscription,
    path: "/dashboard/subscription",
    title: "Subcription",
  },
  {
    component: CreateSubcription,
    path: "/dashboard/subscription/create",
    title: "Create Subscription",
  },
  {
    component: CreateSubcription,
    path: "/dashboard/subscription/edit",
    title: "Edit Subscription",
  },
  {
    component: CashManagement,
    path: "/dashboard/cash-management",
    title: "Counter Opening/Closing",
  },
  {
    component: Expenses,
    path: "/dashboard/expenses-management",
    title: "Expenses Management",
  },
  {
    component: PlanAndPricing,
    path: "/dashboard/plan-and-pricing",
    title: "Plan and Pricing",
  },
  // {
  //   component: SupportForm,
  //   path: "/dashboard/support",
  // },
];
